/* src/app/components/rules/rules.component.scss */
.folha-rules {
  max-width: min(840px, 100vw);
  padding: 3em 1em;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  min-height: calc(100vh - 5rem);
  box-shadow: 6px 6px 12px #222;
}
.folha-rules hr {
  max-width: 50px;
  border-width: 3px;
  border-color: #380415;
}
.folha-rules hr.light {
  border-color: white;
}
.text-regulamento h3 {
  font-size: 1.8rem;
  margin: 2rem 0;
}
.text-regulamento p {
  margin: 2rem 0;
}
/*# sourceMappingURL=rules.component-NV6Z52MR.css.map */
